import { FC, useCallback } from "react";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { DataAction } from "../types/action";
import { ChatOutlined, MarkUnreadChatAltOutlined } from "@mui/icons-material";
import { useRemoteField } from "../hooks/useRemoteField";

export const ThreadToggle: FC<{ questionId: string }> = ({ questionId }) => {
	const dispatch = useDispatch();
	const [threadCount] = useRemoteField(`${questionId}.N_THREADS`);
	const [unresolvedCount] = useRemoteField(`${questionId}.UNRESOLVED`);

	const openThreads = useCallback(() => {
		dispatch<DataAction>({
			type: "UPDATE_DRAWER_STATE",
			update: {
				attachmentsOpen: false,
				threadsOpen: true,
				selectedThreadId: -1,
				filters: { questionId },
			},
		});
	}, []);

	return (
		<IconButton
			aria-label="view threads"
			className="toggle-button"
			sx={{
				// opacity: +threadCount ? 1 : 0,
				display: +threadCount ? "inline-block" : "none",
				transition: "all 0.2s",
			}}
			onClick={openThreads}
			size="small"
		>
			{+unresolvedCount ? (
				<MarkUnreadChatAltOutlined fontSize="small" color="error" />
			) : (
				<ChatOutlined fontSize="small" color="primary" />
			)}
		</IconButton>
	);
};
